import React, { useEffect, useRef } from "react";
import styles from "../style.css";
import store from "src/store";
import { useResizeObserver } from "../../../utils/hooks";

const SideButton = ({
  searchBarSideBtnText,
  searchBarSideBtnDestinationURL,
  searchBarSideBtnBgColor,
  searchBarSideBtnTextColor,
  searchBarSideBtnBorderColor
}) => {
  store.set("searchBarConfig.isSearchBarSideBtnRendered", true);
  const ref = useRef()
  const navHeight = useResizeObserver('section[data-af-component="NavComponent"]', 'height') // Nav Component custom css detection
  
  useEffect(() => {
    var searchIconElem = document.querySelector('button[alt="Submit"] > img'); // Changes the color of the search icon
    searchIconElem.src = searchIconElem.src.replace("fill='%23fff'", "fill='%23737373'").replace("stroke='%238C8C8C'", "stroke='%23737373'");
  }, []);
 
  return (
    <button
      ref={ref}
      onClick={e => {
        e.preventDefault();
        window.location.href = searchBarSideBtnDestinationURL;
      }}
      id="searchBarSideBtn"
      className={styles.sideBtn}
      style={{
        backgroundColor: searchBarSideBtnBgColor || "ef3040",
        color: searchBarSideBtnTextColor || "#fff",
        border: `8px solid ${searchBarSideBtnBorderColor || "#e4e4e4"}`,
        position: "fixed",
        right: 0,
        top: navHeight || 0
      }}
    >
      {searchBarSideBtnText}
    </button>
  );
};

export default SideButton;
